module.exports = __webpack_public_path__ + "img/red-helmet.eb6ed5f7.png";